import {
  AccidentNewYork,
  matchAccidentNewYorkByType,
} from 'ApplicationEntry/models/ProductsRiders/AccidentNewYork/AccidentNewYork';
import * as G from 'ApplicationEntry/models/ProductsRiders/AccidentNewYork/GroupAccidentNewYork';
import * as NY from 'ApplicationEntry/models/ProductsRiders/AccidentNewYork/NewYorkAccidentNewYork';
import {Async, Loading} from 'Core/models/Async';
import {NonEmptyString} from 'Core/models/EmptyString';
import {createAction} from 'Shared/utilities/actionCreator';
import {reverseEnum} from 'Shared/utilities/enumUtility';

export enum AccidentNewYorkActionType {
  CHANGE_PACKAGE = 'accidentNewYork/CHANGE_PACKAGE',
  CHANGE_PLAN_TYPE = 'accidentNewYork/CHANGE_PLAN_TYPE',
  CHANGE_PREMIUM = 'accidentNewYork/CHANGE_PREMIUM',
  CHANGE_CALCULATED_PREMIUM = 'accidentNewYork/CHANGE_CALCULATED_PREMIUM',
  CHANGE_CWA = 'accidentNewYork/CHANGE_CWA',
  CHANGE_SECTION_125 = 'accidentNewYork/CHANGE_SECTION_125',
  CHANGE_REPLACEMENT = 'accidentNewYork/CHANGE_REPLACEMENT',
  CHANGE_POLICY_NUMBER = 'accidentNewYork/CHANGE_POLICY_NUMBER',
  CHANGE_BASE_UNITS = 'accidentNewYork/CHANGE_BASE_UNITS',
  CHANGE_J_STAMP = 'accidentNewYork/CHANGE_J_STAMP',
  CHANGE_SITUS_STATE = 'accidentNewYork/CHANGE_SITUS_STATE',
  CHANGE_PLAN = 'accidentNewYork/CHANGE_PLAN',
  GET_GROUP_ACCIDENT_NEW_YORK_PACKAGES = 'accidentNewYork/GET_GROUP_ACCIDENT_NEW_YORK_PACKAGES',
  CHANGE_GROUP_ACCIDENT_NEW_YORK_PACKAGES = 'accidentNewYork/CHANGE_GROUP_ACCIDENT_NEW_YORK_PACKAGES',
  CHANGE_RIDER_AMOUNT = 'accidentNewYork/CHANGE_RIDER_AMOUNT',
  CHANGE_RIDER_CODES = 'accidentNewYork/CHANGE_RIDER_CODES',
}

export const isAccidentNewYorkAction = (action: any): action is AccidentNewYorkAction =>
  action.type in reverseEnum(AccidentNewYorkActionType);

export const changePackage = (packageName: string) =>
  createAction(AccidentNewYorkActionType.CHANGE_PACKAGE, {packageName});
export const changePlanType = (planType: string) =>
  createAction(AccidentNewYorkActionType.CHANGE_PLAN_TYPE, {planType});
export const changePremium = (premium: string) => createAction(AccidentNewYorkActionType.CHANGE_PREMIUM, {premium});
export const changeCalculatedPremium = (calculatedPremium: string) =>
  createAction(AccidentNewYorkActionType.CHANGE_CALCULATED_PREMIUM, {calculatedPremium});
export const changeCWA = (cwa: string) => createAction(AccidentNewYorkActionType.CHANGE_CWA, {cwa});
export const changeReplacement = (replacement: boolean) =>
  createAction(AccidentNewYorkActionType.CHANGE_REPLACEMENT, {replacement});
export const changeSection125 = (section125: boolean) =>
  createAction(AccidentNewYorkActionType.CHANGE_SECTION_125, {section125});
export const changePolicyNumber = (policyNumber: string) =>
  createAction(AccidentNewYorkActionType.CHANGE_POLICY_NUMBER, {policyNumber});
export const changeBaseUnits = (baseUnits: string) =>
  createAction(AccidentNewYorkActionType.CHANGE_BASE_UNITS, {baseUnits});
export const changeJStamp = (jStamp: boolean) => createAction(AccidentNewYorkActionType.CHANGE_J_STAMP, {jStamp});
export const changeSitusState = (situsState: string) =>
  createAction(AccidentNewYorkActionType.CHANGE_SITUS_STATE, {situsState});
export const changePlan = (plan: string) => createAction(AccidentNewYorkActionType.CHANGE_PLAN, {plan});
export const getGroupAccidentNYPackages = (caseNumber: string, planCode: string) =>
  createAction(AccidentNewYorkActionType.GET_GROUP_ACCIDENT_NEW_YORK_PACKAGES, {caseNumber, planCode});
export const changeGroupAccidentNYPackages = (packages: Async<object[]>) =>
  createAction(AccidentNewYorkActionType.CHANGE_GROUP_ACCIDENT_NEW_YORK_PACKAGES, {packages});
export const changeRiderAmount = (riderAmount: number, index: number) =>
  createAction(AccidentNewYorkActionType.CHANGE_RIDER_AMOUNT, {riderAmount, index});
export const changeRiderCodes = (riderCode: string, index: number) =>
  createAction(AccidentNewYorkActionType.CHANGE_RIDER_CODES, {riderCode, index});

export type AccidentNewYorkAction =
  | ReturnType<typeof changePackage>
  | ReturnType<typeof changePlanType>
  | ReturnType<typeof changePremium>
  | ReturnType<typeof changeCalculatedPremium>
  | ReturnType<typeof changeCWA>
  | ReturnType<typeof changeReplacement>
  | ReturnType<typeof changeSection125>
  | ReturnType<typeof changePolicyNumber>
  | ReturnType<typeof changeBaseUnits>
  | ReturnType<typeof changeJStamp>
  | ReturnType<typeof changeSitusState>
  | ReturnType<typeof changePlan>
  | ReturnType<typeof getGroupAccidentNYPackages>
  | ReturnType<typeof changeGroupAccidentNYPackages>
  | ReturnType<typeof changeRiderAmount>
  | ReturnType<typeof changeRiderCodes>;

type AccidentNewYorkState = AccidentNewYork;

export default (state: AccidentNewYorkState, action: AccidentNewYorkAction): AccidentNewYorkState => {
  switch (action.type) {
    case AccidentNewYorkActionType.CHANGE_PLAN:
      return matchAccidentNewYorkByType<AccidentNewYork>({
        Group: G.changePlan(action.payload.plan),
        NewYork: NY.changePlan(action.payload.plan),
        _: () => state,
      })(state);
    case AccidentNewYorkActionType.CHANGE_PLAN_TYPE:
      return matchAccidentNewYorkByType<AccidentNewYork>({
        Group: G.changePlanType(action.payload.planType),
        NewYork: NY.changePlanType(action.payload.planType),
        _: () => state,
      })(state);
    case AccidentNewYorkActionType.CHANGE_PREMIUM:
      return matchAccidentNewYorkByType<AccidentNewYork>({
        Group: G.changePremium(action.payload.premium),
        NewYork: NY.changePremium(action.payload.premium),
        _: () => state,
      })(state);
      case AccidentNewYorkActionType.CHANGE_CALCULATED_PREMIUM:
        return matchAccidentNewYorkByType<AccidentNewYork>({
          Group: G.changeCalculatedPremium(action.payload.calculatedPremium),
          _: () => state,
        })(state);
    case AccidentNewYorkActionType.CHANGE_CWA:
      return matchAccidentNewYorkByType<AccidentNewYork>({
        Group: G.changeCWA(action.payload.cwa),
        NewYork: NY.changeCWA(action.payload.cwa),
        _: () => state,
      })(state);
    case AccidentNewYorkActionType.CHANGE_REPLACEMENT:
      return matchAccidentNewYorkByType<AccidentNewYork>({
        Group: G.changeReplacement(action.payload.replacement),
        NewYork: NY.changeReplacement(action.payload.replacement),
        _: () => state,
      })(state);
    case AccidentNewYorkActionType.CHANGE_SECTION_125:
      return matchAccidentNewYorkByType<AccidentNewYork>({
        Group: G.changeSection125(action.payload.section125),
        NewYork: NY.changeSection125(action.payload.section125),
        _: () => state,
      })(state);
    case AccidentNewYorkActionType.CHANGE_J_STAMP:
      return matchAccidentNewYorkByType<AccidentNewYork>({
        Group: G.changeJStamp(action.payload.jStamp),
        NewYork: NY.changeJStamp(action.payload.jStamp),
        _: () => state,
      })(state);
    case AccidentNewYorkActionType.CHANGE_POLICY_NUMBER:
      return matchAccidentNewYorkByType<AccidentNewYork>({
        Group: G.changePolicyNumber(NonEmptyString.create(action.payload.policyNumber)),
        NewYork: NY.changePolicyNumber(NonEmptyString.create(action.payload.policyNumber)),
        _: () => state,
      })(state);
    case AccidentNewYorkActionType.CHANGE_BASE_UNITS:
      return matchAccidentNewYorkByType<AccidentNewYork>({
        Group: G.changeBaseUnits(action.payload.baseUnits),
        NewYork: NY.changeBaseUnits(action.payload.baseUnits),
        _: () => state,
      })(state);
    case AccidentNewYorkActionType.CHANGE_SITUS_STATE:
      return matchAccidentNewYorkByType<AccidentNewYork>({
        Group: G.changeSitusState(action.payload.situsState),
        NewYork: NY.changeSitusState(action.payload.situsState),
        _: () => state,
      })(state);
    case AccidentNewYorkActionType.GET_GROUP_ACCIDENT_NEW_YORK_PACKAGES:
      return matchAccidentNewYorkByType<AccidentNewYork>({
        Group: G.changePackageList(new Loading()),
        _: () => state,
      })(state);
    case AccidentNewYorkActionType.CHANGE_GROUP_ACCIDENT_NEW_YORK_PACKAGES:
      return matchAccidentNewYorkByType<AccidentNewYork>({
        Group: G.changePackageList(action.payload.packages),
        _: () => state,
      })(state);
    case AccidentNewYorkActionType.CHANGE_PACKAGE:
      return matchAccidentNewYorkByType<AccidentNewYork>({
        Group: G.changePackage(action.payload.packageName),
        _: () => state,
      })(state);
    case AccidentNewYorkActionType.CHANGE_RIDER_AMOUNT:
      return matchAccidentNewYorkByType<AccidentNewYork>({
        Group: G.changeRiderAmount(action.payload.riderAmount, action.payload.index),
        _: () => state,
      })(state);
    default:
      return state;
  }
};
